import { Check, X } from "lucide-react";
import { FOR, NOT_FOR } from "@/data/content";
import { Reveal } from "./Reveal";

const Col = ({ title, items, good, testId }) => (
  <div data-testid={testId} className="flex gap-5 p-6">
    <span className={`grid h-12 w-12 shrink-0 place-items-center rounded-full text-white shadow-md ${good ? "bg-[#0E9384]" : "bg-[#0B1B33]"}`}>
      {good ? <Check className="h-7 w-7" strokeWidth={3} /> : <X className="h-7 w-7" strokeWidth={3} />}
    </span>
    <div>
      <h3 className="font-display text-[18px] font-bold text-[#0B1B33]">{title}</h3>
      <ul className="mt-2 list-disc space-y-1 pl-4 text-[14px] text-slate-700">
        {items.map((t) => <li key={t}>{t}</li>)}
      </ul>
    </div>
  </div>
);

export const WhoFor = () => (
  <Reveal>
    <section id="who" data-testid="who-section" className="grid rounded-2xl border border-slate-200 bg-white md:grid-cols-2 md:divide-x divide-y md:divide-y-0 divide-slate-200">
      <Col title="Who this is for" items={FOR} good testId="for-list" />
      <Col title="Who this may not be for" items={NOT_FOR} testId="not-for-list" />
    </section>
  </Reveal>
);
